import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as actions from '../actions/instructor';
var initialState = {
  isProcessing: false,
  data: [],
  error: null
};
export default reducerWithInitialState(initialState).case(actions.requestInstructors, function (state) {
  return Object.assign({}, state, {
    isProcessing: true
  });
}).case(actions.successInstructors, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    data: payload,
    error: null
  });
}).case(actions.failureInstructors, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: payload
  });
});